export default __webpack_public_path__ + "static/wtf-66145d82a33b41b17391375ebe81f7ce.jpg";